export enum DocumentsHistoryDrawerEvents {
  DOCUMENT_HISTORY_SCROLL_BOTTOM = 'document-history-scroll-bottom',
}
